const axiosInstanceWeb = require("./axiosInstanceWeb");

const login = async (dataReq) => {
    try {
        const response = await axiosInstanceWeb.post("/login", dataReq);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getLinkForgotPassword = async (dataReq) => {
    try {
        const response = await axiosInstanceWeb.post(
            "/password/email",
            dataReq
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

const resetPassword = async (dataReq) => {
    try {
        const response = await axiosInstanceWeb.post(
            "/password/reset",
            dataReq
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

const AuthService = {
    login,
    getLinkForgotPassword,
    resetPassword,
};

module.exports = AuthService;
